import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { FacultyRestrictionItem } from '../../types';
import { RestrictionReset } from './types';
import { RESTRICTION_UNITS } from '../../../../../../constants/restriction';

@Component({
  selector: 'app-faculties-selection-list-restriction-form',
  templateUrl: './faculties-selection-list-restriction-form.component.html',
  styleUrl: './faculties-selection-list-restriction-form.component.scss',
})
export class FacultiesSelectionListRestrictionFormComponent
  implements OnInit, OnDestroy
{
  @Input() restriction: FacultyRestrictionItem;
  @Output() resetRestriction = new EventEmitter<RestrictionReset>();

  restrictionUnitOptions = RESTRICTION_UNITS.map(({ type, values }) => ({
    label: type,
    options: values.map(({ displayName, value }) => ({
      label: displayName,
      value,
    })),
  }));

  private unitSubscription: Subscription;

  ngOnInit() {
    this.unitSubscription =
      this.restriction.controls.unit.valueChanges.subscribe((selectedUnit) => {
        if (selectedUnit) {
          const defaultValue = this.findDefaultValueByUnitValue(selectedUnit);
          this.restriction.controls.value.setValue(defaultValue);
        }
      });
  }

  findDefaultValueByUnitValue(unitValue: string | number): string {
    for (const group of RESTRICTION_UNITS) {
      const valueObj = group.values.find((v) => v.value === unitValue);

      if (valueObj) {
        return valueObj.defaultValue;
      }
    }
    return '';
  }

  ngOnDestroy() {
    if (this.unitSubscription) {
      this.unitSubscription.unsubscribe();
    }
  }
}
